import React from 'react';
import { Router, Route, BrowserRouter, Switch } from "react-router-dom";
import { connect } from 'react-redux';
import './styles/main.css';
import history from './history';

import Header from './components/Header';
import Navbar from './components/Navbar';
import Public from './components/Public';

import ChronicDisease from './components/pages/ChronicDisease';
import HealthAssessment from './components/pages/HealthAssessment';
import MentalHealth from './components/pages/MentalHealth';
import Summary from './components/pages/Summary';
import UserPage from './components/pages/UserPage';
import PatientSelect from './components/pages/PatientSelect';
import Pain from './components/pages/Pain';
import Palliative from './components/pages/Palliative';
import Photo from './components/pages/Photo';
import AOD from './components/pages/AOD';


class App extends React.Component {

    render() {  

        if (this.props.isSignedIn) {
            return (
                <div>  
                    <BrowserRouter history={history}>
                    <div>
                    <Header />
                    <Navbar />
                
                    <Switch />
                        <Route path="/" exact component={PatientSelect} />
                        <Route path="/Summary/:id" exact component={Summary} />
                        <Route path="/ChronicDisease/:id" exact component={ChronicDisease} />
                        <Route path="/MentalHealth/:id" exact component={MentalHealth} />
                        <Route path="/HealthAssessment/:id" exact component={HealthAssessment} />
                        <Route path="/AOD/:id" exact component={AOD} />
                        <Route path="/Pain/:id" exact component={Pain} />
                        <Route path="/Photo/:id" exact component={Photo} />
                        <Route path="/Palliative/:id" exact component={Palliative} />
                        <Route path="/UserPage" exact component={UserPage} />
                    <Switch />
                 
                    </div>
                    </BrowserRouter>
                </div>
            );
        }

        return (
            <div>  
                <Router history={history}>
            <div>
                <Header />
                <Public />
            
            </div>
                </Router>
        </div>
           
        )
    }
};

const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn
    };
}

export default connect (mapStateToProps)(App);